import { connect } from 'react-redux';
import { getAvailableEntertainments } from '../redux/actions/availableEntertainments';
import { getBookedEntertainments } from '../redux/actions/bookedEntertainments';
import { getBackstopDateFromApi } from '../redux/actions/backstopDate';
import Swimming from '../components/swimming/Swimming';
import {
  shouldFetch,
  getShouldFetchAvailableEntertainments,
  getIfAllowedToBook,
  filterActivitiesByBackstop,
  shouldFetchBackstopDate,
} from '../utils';

const mapStateToProps = ({
  availableEntertainments,
  bookingSearch,
  bookedEntertainments,
  bookedEvents,
  config,
  backstopDate,
}, {
  isSummaryPage,
  detailPage,
}) => {
  const { isAllowedToBookSwimming } = getIfAllowedToBook(bookingSearch, config);
  const { arrivalDate, departureDate, resId, siteCode, seasonSuffix, isEarlyAccess } = bookingSearch;
  const splashEntertainments = availableEntertainments.splashEntertainments.filter(({ events }) => events && events.length > 0);

  return {
    splashEntertainments: filterActivitiesByBackstop(
    splashEntertainments, 
    config,
    departureDate, 
    arrivalDate, 
    seasonSuffix, 
    isEarlyAccess, 
    backstopDate.backstopDate),
    title: 'Setup your experience',
    subTitle: 'Swimming',
    resId,
    siteCode,
    arrivalDate,
    shouldFetchAvailableEntertainments: getShouldFetchAvailableEntertainments(availableEntertainments, bookedEntertainments, bookingSearch, config),
    shouldFetchBookedEntertainments: shouldFetch(bookedEntertainments, bookingSearch, config),
    bookedEvents: bookedEvents.events,
    isSummaryPage,
    detailPage,
    swimmingInterval: parseInt(config.REACT_APP_SWIMMING_INTERVAL, 10) || 90,
    // showSwimmingWarning: true, | Show swimming message about government advice.
    isAllowedToBookSwimming,
    swimmingFreeFlowMessage: availableEntertainments.swimmingFreeFlowMessage,
    shouldFetchBackstopDate: shouldFetchBackstopDate(config, backstopDate, bookingSearch),
  };
};

const mapDispatchToProps = dispatch => ({
  getAvailableEntertainments: siteCode => dispatch(getAvailableEntertainments(siteCode)),
  getBookedEntertainments: (resId, siteCode) => dispatch(getBookedEntertainments(resId, siteCode)),
  getBackstopDateFromApi: () => dispatch(getBackstopDateFromApi()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Swimming);
